import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';

const FieldInput = ({ f, value, onChange, payers, referralSources, testid }) => {
  const v = value ?? '';
  if (f.type === 'select') {
    return (
      <select value={v} onChange={(e) => onChange(e.target.value)} data-testid={testid}
        className="w-full h-9 rounded-xl border border-[#E5E0EA] bg-white px-3 text-sm">
        {f.options.map((o) => <option key={o} value={o}>{o || '—'}</option>)}
      </select>
    );
  }
  if (f.type === 'referral') {
    return (
      <select value={v} onChange={(e) => onChange(e.target.value)} data-testid={testid}
        className="w-full h-9 rounded-xl border border-[#E5E0EA] bg-white px-3 text-sm">
        <option value="">—</option>
        {[...new Set([...(referralSources || []), ...(v ? [v] : [])])].map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    );
  }
  if (f.type === 'payer') {
    return (
      <>
        <Input list="ludo-payers" value={v} onChange={(e) => onChange(e.target.value)} className="rounded-xl h-9" data-testid={testid} placeholder="Pick or type a payer" />
        <datalist id="ludo-payers">{payers.map((p) => <option key={p} value={p} />)}</datalist>
      </>
    );
  }
  if (f.type === 'textarea') {
    return <Textarea value={v} onChange={(e) => onChange(e.target.value)} rows={2} className="rounded-xl" data-testid={testid} />;
  }
  const type = f.type === 'date' ? 'date' : (f.type === 'money' || f.type === 'number') ? 'number' : 'text';
  return <Input type={type} step="any" value={v} onChange={(e) => onChange(e.target.value)} className="rounded-xl h-9" data-testid={testid} />;
};

export const SectionForm = ({ section, values, onChange, payers, referralSources }) => (
  <div className="grid sm:grid-cols-2 gap-x-4 gap-y-3" data-testid={`ludo-section-${section.key}`}>
    {section.fields.map((f) => (
      <label key={f.key} className={`block ${f.type === 'textarea' ? 'sm:col-span-2' : ''}`}>
        <span className="text-[11px] uppercase tracking-wider text-[#6E5F78] font-semibold">{f.label}{f.type === 'money' ? ' ($)' : ''}</span>
        <div className="mt-1">
          <FieldInput f={f} value={values?.[f.key]} payers={payers} referralSources={referralSources}
            onChange={(val) => onChange(f.key, val)} testid={`ludo-field-${section.key}-${f.key}`} />
        </div>
      </label>
    ))}
  </div>
);

export default SectionForm;
